/** ***
------------------------------------------------------------------------
CONTAINER LIST PAGE
------------------------------------------------------------------------
 {
    containerViews: [{active: false, cloudType: "AWS",…}]
    imageId: "docker-pullable://registry.gitlab.com/gitlab-org/build/cng/kubectl@sha256:99931bd06b4154bc420929ea24a55a367f8aa2dd5d0629f0c376476c038cd2bd"
    imageName: "registry.gitlab.com/gitlab-org/build/cng/kubectl:1.13.12"
    imageNames: []
    numContainers: 1
    numDetections: 0
    numProgressions: 0
    snykAccountSet: []
    snykPresence: false
    snykProjects: []
    vulnHighScore: 0
    vulnLowScore: 0
    vulnMedScore: 0
    vulnerable: "UNKNOWN"
    },

** ***/

const containerImagesDetailMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'expand',
        description: 'More Details',
        label: 'More Details',
        sortable: false,
        'min-width': 150,
        name: 'expand',
        component: 'ExpandContainerImageDetails'
      },
      {
        datatype: 'string',
        description: 'Image Name',
        label: 'Image Name',
        sortable: true,
        'min-width': 250,
        name: 'imageName'
      },
      {
        datatype: 'number',
        description: 'Active Containers',
        label: 'Active Containers',
        sortable: true,
        name: 'numContainers',
        display: 'link',
        pathTo: 'account-containers',
        query: [
          {
            name: 'type',
            keyLookup: 'apiType'
          },
          {
            name: 'accountKey',
            keyLookup: 'imageId'
          },
          {
            name: 'nickName',
            keyLookup: 'imageName'
          }
        ],
        'min-width': 125
      },
      {
        datatype: 'string',
        description: 'Vulnerable',
        label: 'Vulnerable',
        sortable: true,
        name: 'vulnerable',
        display: 'component',
        component: 'SnykVulnerableTableCell',
        componentFields: {
          snykPresence: 'snykPresence',
          vulnLowScore: 'vulnLowScore',
          vulnMedScore: 'vulnMedScore',
          vulnHighScore: 'vulnHighScore',
          vulnerable: 'vulnerable'
        },
        'min-width': 125
      },
      {
        datatype: 'string',
        description: 'Needs Attention',
        label: 'Attention',
        name: 'needsAttention',
        sortable: true,
        'min-width': 100,
        display: 'component',
        component: 'ContainerImageNeedsAttentionTableCell',
        componentFields: {
          needsAttention: 'needsAttention',
          snykPresence: 'snykPresence',
          vulnLowScore: 'vulnLowScore',
          vulnMedScore: 'vulnMedScore',
          vulnHighScore: 'vulnHighScore',
          vulnerable: 'vulnerable',
          numProgressions: 'numProgressions',
          accountKey: 'imageId',
          nickName: 'imageName'
        }
      },
      {
        datatype: 'number',
        description: 'Progressions',
        label: 'Progressions',
        sortable: true,
        'min-width': 125,
        name: 'numProgressions',
        display: 'link',
        pathTo: 'account-progressions',
        query: [
          {
            name: 'accountKey',
            keyLookup: 'imageId'
          },
          {
            name: 'nickName',
            keyLookup: 'imageName'
          }
        ]
      },
      {
        datatype: 'number',
        description: 'Detections',
        label: 'Detections',
        sortable: true,
        name: 'numDetections',
        'min-width': 110,
        display: 'link',
        pathTo: 'account-iocs',
        query: [
          {
            name: 'accountKey',
            keyLookup: 'imageId'
          },
          {
            name: 'nickName',
            keyLookup: 'imageName'
          }
        ]
      },
      {
        datatype: 'string',
        description: 'Image Id',
        label: 'Image Id',
        sortable: true,
        name: 'imageId',
        'min-width': 225
      }
    ]
  }
}

export { containerImagesDetailMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/hosts/container-images-meta.js